<template>
  <div class="cleaning-form">
    <validation-observer
      ref="formValidation"
    >
      <!-- Cleaning Location Section -->
      <validation-provider
        v-slot="{ errors }"
        :name="$t('field.address')"
        rules="required"
      >
        <b-form-group
          :label="$t('field.cleaningLocation')"
          :state="errors.length === 0 ? null : false"
          class="mb-2"
        >
          <b-form-textarea
            v-model="formData.address"
            :rows="2"
            :state="errors.length === 0 ? null : false"
            :placeholder="$t('placeholder.enterAddress')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>

      <!-- Charge Type Section -->
      <validation-provider
        v-slot="{ errors }"
        :name="$t('field.chargeType')"
        rules="required"
      >
        <b-form-group
          :label="$t('field.chargeType')"
          :state="errors.length === 0 ? null : false"
          class="mb-2"
        >
          <b-form-radio-group
            v-model="formData.chargeType"
            :options="[
              { text: $t('field.singlePayment'), value: 'single' }
            ]"
            :state="errors.length === 0 ? null : false"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>

      <!-- Service Time Section -->
      <validation-provider
        v-slot="{ errors }"
        :name="$t('field.scheduleType')"
        rules="required"
      >
        <b-form-group
          :label="$t('field.serviceTime')"
          :state="errors.length === 0 ? null : false"
          class="mb-2"
        >
          <b-form-radio-group
            v-model="formData.scheduleType"
            :options="[
              { text: $t('field.immediately'), value: 1 },
              { text: $t('field.customTime'), value: 2 }
            ]"
            :state="errors.length === 0 ? null : false"
          />
          <n-date-time-picker
            v-if="formData.scheduleType === 2"
            v-model="formData.scheduleDate"
            :state="errors.length === 0 ? null : false"
            :disable-before-today="true"
            :disable-after-today="false"
            class="mt-2"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormRadioGroup,
  BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import NDateTimePicker from '@/components/NDateTimePicker.vue'

export default {
  name: 'CleaningForm',

  components: {
    BFormGroup,
    BFormRadioGroup,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    NDateTimePicker,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      formData: {
        scheduleType: 1,
        scheduleDate: '',
        address: '',
        chargeType: 'single',
      },
    }
  },

  watch: {
    value: {
      handler(newValue) {
        if (newValue && JSON.stringify(newValue) !== JSON.stringify(this.formData)) {
          this.formData = {
            scheduleType: newValue.scheduleType ?? 1,
            scheduleDate: newValue.scheduleDate ?? '',
            address: newValue.address ?? '',
            chargeType: newValue.chargeType ?? 'single',
          }
        }
      },
      immediate: true,
      deep: true,
    },
    formData: {
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.value)) {
          this.$emit('input', { ...newValue })
        }
      },
      deep: true,
    },
  },

  methods: {
    async validate() {
      if (this.$refs.formValidation) {
        return this.$refs.formValidation.validate()
      }
      return false
    },

    reset() {
      this.formData = {
        scheduleType: 1,
        scheduleDate: null,
        address: '',
        chargeType: 'single',
      }
      if (this.$refs.formValidation) {
        this.$refs.formValidation.reset()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cleaning-form {
  .form-group:last-child {
    margin-bottom: 0;
  }

  .price-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }

  .price-card {
    background-color: #f8f9fa;
    border-radius: 0.5rem;
    padding: 1rem;
    text-align: center;

    .price {
      font-size: 1.25rem;
      font-weight: 600;
      margin-bottom: 0.25rem;
    }

    .label {
      font-size: 0.875rem;
      color: #6c757d;
    }
  }
}
</style>